export default __webpack_public_path__ + "static/media/check.49c31a50.svg";